"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cachePromise = cachePromise;
exports.getChannelByToken = getChannelByToken;
var _api = require("@whitbread-eos/api");
var _getters = require("../getters");
function cachePromise(fn) {
  var cache = new Map();
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    var key = JSON.stringify(args);
    if (!cache.has(key)) {
      var promise = fn(...args);
      cache.set(key, promise);
    }
    return cache.get(key);
  };
}
function getChannelByToken(token) {
  if (!token) {
    return null;
  }
  var {
    accessLevel,
    companyId,
    employeeId,
    profile,
    customerId
  } = (0, _getters.getDetailsFromToken)(token);
  if (accessLevel && companyId && employeeId && profile && profile !== null && profile !== void 0 && profile.isBusiness) {
    return _api.Channel.Bb;
  }
  if (customerId && !(profile !== null && profile !== void 0 && profile.isBusiness) && !accessLevel) {
    return _api.Channel.Pi;
  }
  return null;
}